import {
  List,
  Table,
  TableRow,
  TableHeader,
  TableHeaderCell,
  Text,
  TableBody,
  TableCell,
} from 'braid-design-system';

export const MinimumFieldList = () => (
  <Table label="Fields">
    <TableHeader>
      <TableRow>
        <TableHeaderCell>
          <Text>Category</Text>
        </TableHeaderCell>
        <TableHeaderCell>
          <Text>Required fields</Text>
        </TableHeaderCell>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableCell>
          <Text>Personal details</Text>
        </TableCell>
        <TableCell>
          <List>
            <Text>First name</Text>
            <Text>Last name</Text>
            <Text>Phone number</Text>
            <Text>Email address</Text>
          </List>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Text>Career history</Text>
        </TableCell>
        <TableCell>
          <List>
            <Text>Job title</Text>
            <Text>Company name</Text>
            <Text>Started</Text>
            <Text>Ended</Text>
            <Text>Description</Text>
          </List>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Text>Attachments</Text>
        </TableCell>
        <TableCell>
          <List>
            <Text>Resume file</Text>
          </List>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
